<template>
    <div>
        <div class="ml-10 border pr-10 pl-10 bg-gray-100 lg:ml-0 lg:mt-10">
            <div class="flex justify-between mt-6 md:flex-col">
                <p class="text-blue-600 text-lg font-semibold">Tracking</p>
                <form @submit.prevent="checkTrackingNumber">
                    <div v-if="notFound" class=" text-red-500 text-xs mb-4">
                        <p>Tracking Number is incorrect</p>
                    </div>
                    <div class="flex">
                        <div>
                            <input class="border outline-none w-full text-xs p-2 border-blue-600 rounded-xl" type="text" name="trackingNumber" id="trackingNumber" placeholder="Enter your tracking No." v-model="trackingNumber">
                            <p v-if="numberValidity === 'invalid' " class=" text-xs text-red-500">Please enter your tracking Number</p>
                        </div>
                        
                        <div class="flex">
                            <button class=" bg-blue-600 text-white ml-6 p-2 rounded-xl">GO</button>
                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                        </div>
                    </div>
                </form>
            </div>

            <!-- ----------TRACKING PROGRESS---------- -->
            <div class="flex mt-10 md:flex-col">
                <div class="w-1/2 md:w-full bg-blue-700 text-sm pl-8 pr-8 pt-6 pb-4 text-white rounded-xl">
                    <div v-if="trackingDetails.status !== 'processing' && trackingDetails.status !== 'completed'" class="relative">
                        <p class="absolute top-10 z-20 left-16">%</p>
                        <circle-progress :percent="0" :is-gradient="true"  :size="100" :show-percent="true" class="text-xl text-white flex justify-center"  />
                    </div>
                    <div class="relative" v-if="trackingDetails.status == 'started'">
                        <p class="absolute top-10 z-20 left-16">%</p>
                        <circle-progress :percent="25" :is-gradient="true"  :size="100" :show-percent="true" class="text-xl text-white flex justify-center"  />
                    </div>
                    <div class="relative" v-if="trackingDetails.status == 'picked'">
                        <p class="absolute top-10 z-20 left-16">%</p>
                        <circle-progress :percent="50"  :is-gradient="true" :size="100" :show-percent="true" class="text-xl text-white flex justify-center"  />
                    </div>
                     <div class="relative" v-if="trackingDetails.status == 'processing'">
                        <p class="absolute top-10 z-20 left-16">%</p>
                        <circle-progress :percent="75"  :is-gradient="true" :size="100" :show-percent="true" class="text-xl text-white flex justify-center"  />
                    </div>
                     <div class="relative" v-if="trackingDetails.status == 'completed'">
                        <p class="absolute top-10 z-20 left-16">%</p>
                        <circle-progress :percent="100"  :is-gradient="true" :size="100" :show-percent="true" class="text-xl text-white flex justify-center"  />
                    </div>
                    <div>
                        <div class="mt-4">
                            <p>Tracking Number</p>
                            <p class="text-xs text-gray-300">{{trackingDetails.trackingNumber}}</p>
                        </div>

                        <div class="mt-4">
                            <p>Customer</p>
                            <p class="text-xs text-gray-300">{{trackingDetails.customerName}}</p>
                        </div>

                        <div v-if="trackingDetails.status == 'processing' && trackingDetails.orderType !== 'bookARide'" class="mt-4">
                            <p>Estimated Delivery Time</p>
                            <p class="text-xs text-gray-300">{{trackingDetails.deliveryTime}}</p>
                        </div>
                        <div v-if="trackingDetails.status == 'completed '  && trackingDetails.orderType !== 'bookARide'" class="mt-4">
                            <p>Delivery Time</p>
                            <p class="text-xs text-gray-300">{{trackingDetails.deliveryTime}}</p>
                            
                        </div>
                    </div>
                    
                </div>
                <div class="ml-5 bg-gray-50 p-4 md:mt-10 md:ml-0">
                    <div> 
                        <div class=" font-semibold">
                            <p>Journey details</p>
                        </div>

                        <div class=" mt-8 text-sm">
                            <div class=" flex">
                                <div class=" relative">
                                    <img src="../assets/Oval1.png" alt="">
                                    <img class=" absolute left-4" src="../assets/Line1.png" alt="">
                                </div>
                                <div class=" ml-2">
                                    <p v-if="trackingDetails.orderType == 'bookARide' " class=" text-blue-700">{{trackingDetails.customerName}}'s carrier accepts the Trip</p>
                                    <p v-else class=" text-blue-700">{{trackingDetails.customerName}}'s carrier accepts the Delivery</p>
                                    <div class=" flex mt-2">
                                        <div>
                                            <img src="../assets/calendar-date.png" alt="calendar">
                                        </div>
                                        <div class=" ml-2">
                                            <p class="text-xs">{{moment(trackingDetails.created_at).format("MM/DD/YYYY - hh:mma")}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class=" mt-2">
                                <div class=" flex">
                                    <div class=" relative">
                                        <img src="../assets/Oval2.png" alt="icon">
                                        <img class=" absolute left-4" src="../assets/Line1.png" alt="blue-line">
                                    </div>
                                    <div class=" ml-2">
                                        <p class=" text-blue-700">Carrier picks up Item(s)</p>
                                        <div class=" flex mt-2">
                                            <div>
                                                <img src="../assets/calendar-date.png" alt="calendar">
                                            </div>
                                            <div class=" ml-2">
                                                <p class="text-xs">{{moment(trackingDetails.created_at).format("MM/DD/YYYY - hh:mma")}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class=" mt-2">
                                <div class=" flex">
                                    <div class=" relative">
                                        <img src="../assets/Oval3.png" alt="icon">
                                        <img class=" absolute left-5" src="../assets/grey-line.png" alt="grey-line">
                                    </div>
                                    <div class=" ml-2">
                                        <p class=" text-blue-700">Enroute destination</p>
                                        <div class=" flex mt-2">
                                            <div>
                                                <img src="../assets/calendar-date.png" alt="calendar">
                                            </div>
                                            <div class=" ml-2">
                                                <p class="text-xs">{{moment(trackingDetails.updated).format("MM/DD/YYYY - hh:mma")}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class=" mt-3">
                                <div class=" flex">
                                    <div>
                                        <img src="../assets/Oval4.png" alt="">
                                    </div>
                                    <div class=" ml-2">
                                        <p v-if="trackingDetails.status === 'completed' && trackingDetails.orderType == 'bookARide' " class="completed">Trip completed</p>
                                        <p v-else-if="trackingDetails.status === 'completed' " class="completed">Delivery completed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import moment from 'moment';
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        CircleProgress
    },

    data() {
        return {
            trackingNumber: '',
            numberValidity: '',
            isLoading: false,
            notFound: false,
            trackingDetails: [],
            status: "",
            token: localStorage.getItem("token")
        }
    },

    mounted() {
        this.getTrackingNumber()
    },

    methods: {
        moment(date) {
            return moment(date)
        },
        checkTrackingNumber() {
            if (!this.trackingNumber) {
                this.numberValidity = 'invalid';
                setTimeout(() => {
                    this.numberValidity = ""
                }, 3000);
            } else {
                this.isLoading = true
                axios({
                    method: 'GET',
                    url: `${url}/v1/web/orders/${this.trackingNumber}`,
                    headers: {
                        'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                })
                .then((response) => {
                    this.isLoading = false
                    response.json;
                    this.getTrackingNumber()
                    this.trackingNumber = ""
                })
                .catch((error) => {
                    if(error.response.data.code === 404) {
                        this.notFound = true
                    }
                    setTimeout(() => {
                        this.notFound = false
                    }, 3000);
                    this.isLoading = false
                    error.json
                })
            }
        },

        getTrackingNumber() {
                axios({
                    method: 'GET',
                    url: `${url}/v1/web/orders/${this.trackingNumber}`,
                    headers: {
                        'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                })
                .then((response) => {
                    this.trackingDetails = response.data.data;
                    if(response.data.data.status === "completed") {
                        this.status = "completed";
                    }
                    this.isLoading = false
                })
                .catch((error) => {
                    error.json
                })
            
        }
    }
}
</script>

<style scoped>
.completed {
    color: green;
}
</style>